import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  svgContent: any;
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }


  ngOnInit(): void {
    this.loadSVG();
  }

  loadSVG() {
    this.http.get('../../../../../assets/SVG/logo.svg', { responseType: 'text' })
      .subscribe(svgData => {
        this.svgContent = this.sanitizer.bypassSecurityTrustHtml(svgData);
      });
  }

  scrollUpToAboutus() {
    var element: any = document.querySelector('body');
    console.log(element.scrollHeight)
    element.scrollTo({
      top: element.scrollHeight - 1320,
      behavior: 'smooth',
    })
  }


}
